//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet, axiosPost } from '../../../../axios/axios'

export default {
  name: 'UserNotifications',
  data: function () {
    const columns = [{
      name: 'name',
      label: 'Тип оповещения',
      align: 'left',
      sortable: true
    }]

    const chanels = [
      {
        key: 'email',
        name: 'Email-уведомления',
        shortName: 'Почта',
        allowProperty: 'allowEmail'
      },
      {
        key: 'account',
        name: 'Уведомления в интерфейсе',
        shortName: 'Интерфейс',
        allowProperty: 'allowAccount'
      },
      {
        key: 'webpush',
        name: 'Push-уведомления',
        shortName: 'Push',
        notificationProperty: 'webPush',
        allowProperty: 'allowWebPush'
      },
      {
        key: 'telegram',
        name: 'Уведомления Telegram',
        shortName: 'Telegram',
        allowProperty: 'allowTelegram'
      },
      {
        key: 'max',
        name: 'Уведомления Max',
        shortName: 'Max',
        allowProperty: 'allowMax'
      }
    ]
    for (const channel of chanels) {
      if (!channel.shortName) {
        channel.shortName = channel.name
      }
      if (!channel.notificationProperty) {
        channel.notificationProperty = channel.key
      }
      columns.push({
        _chanel: channel,
        name: channel.notificationProperty,
        label: channel.shortName,
        align: 'center',
        sortable: true
      })
    }
    for (const column of columns) {
      column.field = column.name
    }

    return {
      notifications: [],
      notificationsInitial: [],
      pagination: {
        rowsPerPage: 0
      },
      columns: columns,
      chanels: chanels
    }
  },
  created: function () {
    axiosGet({
      url: '/service/delta/userevents/geteventtypes',
      onSuccess: (response) => {
        this.notifications = response.data.map(notification => {
          return {
            type: notification.type,
            name: notification.name,
            email: notification.email,
            account: notification.account,
            webPush: notification.webPush,
            telegram: notification.telegram,
            max: notification.max,
            allowEmail: notification.allowEmail,
            allowAccount: notification.allowAccount,
            allowWebPush: notification.allowWebPush,
            allowTelegram: notification.allowTelegram,
            allowMax: notification.allowMax
          }
        })
        this.notificationsInitial = JSON.parse(JSON.stringify(this.notifications))
      },
      onFailure: 'Ошибка получения типов оповещений'
    })
  },
  methods: {
    saveChanges: async function () {
      this.$q.loading.show({ spinnerColor: 'blue-11' })
      try {
        // TODO сохранять одним запросом все каналы
        for (const chanel of this.chanels) {
          await this.saveChanelChanges(chanel)
        }
      } finally {
        this.$q.loading.hide()
        this.notificationsInitial = JSON.parse(JSON.stringify(this.notifications))
      }
    },
    saveChanelChanges: function (chanel) {
      const types = this.notifications.filter(notification => notification[chanel.notificationProperty] === true).map(notification => notification.type)
      const typesInitial = this.notificationsInitial.filter(notification => notification[chanel.notificationProperty] === true).map(notification => notification.type)
      if (JSON.stringify(types) === JSON.stringify(typesInitial)) {
        return Promise.resolve()
      }
      return this.changeNotification(chanel, types)
    },
    changeNotification: function (chanel, types) {
      const bodyFormData = new FormData()
      bodyFormData.set('channel', chanel.key)
      bodyFormData.set('types', types.join(','))
      return axiosPost({
        url: '/service/delta/userevents/seteventtypes',
        data: bodyFormData,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Сохранено: ' + chanel.name,
            progress: true,
            timeout: 4000
          })
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: `"${chanel.name}": Ошибка сохранения`,
            progress: true,
            timeout: 8000
          })
        }
      })
    }
  }
}
